import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'sol-editor',
  templateUrl: './editor.component.html',
  providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditorComponent),
      multi: true
  }]
})
export class EditorComponent implements ControlValueAccessor{

  @Input()
  disabled: boolean;

  private _richText: string;

  get richText() {
    return this._richText;
  }

  set richText(val) {
    this._richText = val;
    this.onModelChange(this._richText);
  }

  onModelChange: (_: any) => void = (_: any) => {
  };
  onModelTouched: () => void = () => {
  };

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    if(obj){
      this.richText = <string> obj;
    }else{
      this.richText = "";
    }
  }

}
